import React, { useEffect, useState } from "react";
import { useStyles } from "pages/c-dad-datavisualization/style";
import SummaryStatisticsDataTable from "shared-component/summary-statistics";
import SummaryStatisticsFilterComponent from "./components/SummaryStatisticsFilterComponent";
import { DynamicDataItem, FilterOptions } from "utility/types";
import { JobDetail } from "pages/c-dad-user-data";

interface SummaryStatisticsDataVisualizationProps {
    subJobs?: any;
    expanded: string;
    jobDetails: JobDetail[];
    userInputData: string[];
}


const SummaryStatisticsDataVisualization: React.FC<SummaryStatisticsDataVisualizationProps> = ({ subJobs, expanded, jobDetails, userInputData }) => {
    const classes = useStyles();
    const cDadDataVisualizationData: any = {};
    const [summaryStatsData, setSummaryStatsData] = useState<DynamicDataItem<number | string>[]>([]);
    const [dataTriggered, setDataTriggered] = useState<boolean>(false);
    useEffect(() => {
        if (cDadDataVisualizationData?.length > 0 && dataTriggered) {
            const inputData: any[] = [];
            cDadDataVisualizationData?.forEach((item: any) => {
                let updatedItem: any = {};
                for (const [key, value] of Object.entries(item)) {
                    if (key?.indexOf('_') >= 0) {
                        const keyElement: string = key?.split('_')[0];
                        updatedItem[keyElement] = value
                    } else {
                        updatedItem = value
                    }
                }
                inputData.push(updatedItem);
            })
            setSummaryStatsData(inputData);
        }
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cDadDataVisualizationData.data, dataTriggered]);


    const getFilteredSUmmaryStat = (filterOptions: FilterOptions) => {
        const { signal, groupBy, aggregation } = filterOptions;
        console.log('signal, groupBy, aggregation', signal, groupBy, aggregation)
        setDataTriggered(true)
    }

    return (
        <>
            {expanded === 'panel6' ? <div>{cDadDataVisualizationData?.isLoading && (
                <div className={classes.overlay}>
                    <div className={classes.loader}></div>
                </div>
            )}
                <SummaryStatisticsFilterComponent signalList={userInputData} getFilteredSUmmaryStat={getFilteredSUmmaryStat} />
                {summaryStatsData?.length > 0 && <SummaryStatisticsDataTable data={summaryStatsData} />}</div>
                : null}
        </>
    );
};

export default SummaryStatisticsDataVisualization;
